import React from "react";
import { Divider, Grid } from "@mui/material";
import cssExports from "theme/styles/main.module.scss";
import DetailTableViewSmallRowSkeleton from "./detailTableViewSmallRowSkeleton";

const DetailTableSkeleton: React.FC = () => {
  return (
    <Grid container borderRadius={4} bgcolor={"white"} width={"100%"} direction="column" wrap="nowrap">
      <DetailTableViewSmallRowSkeleton />
      <Divider flexItem className={cssExports.dividerGray} />
      <DetailTableViewSmallRowSkeleton />
      <Divider flexItem className={cssExports.dividerGray} />
      <DetailTableViewSmallRowSkeleton />
      <Divider flexItem className={cssExports.dividerGray} />
      <DetailTableViewSmallRowSkeleton />
      <Divider flexItem className={cssExports.dividerGray} />
      <DetailTableViewSmallRowSkeleton />
    </Grid>
  );
};

export default DetailTableSkeleton;
